module.exports = __webpack_public_path__ + "static/media/ruins_captain_mac.d48424b3.png";